module.exports = __webpack_public_path__ + "static/media/barnReconsile.4a741bf7.jpg";